import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderTypeQuickInfo extends Layout {
    labelLabel1: Label;
    panelColor: Panel;
    panelColorDisplay: Panel;
    panelOrderTypeQuickInfo: Panel;
    sourceOrderType: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxOrderMode: Textbox;
}
